export default __webpack_public_path__ + "static/media/Banner-1-Back.05298301.jpg";